<template>
    <div>
        <modal ref="modal" :disable-close="true">
            paypal {{ method }}
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            method: String,
            plan: String
        },

        mounted() {
            this.$refs.modal.open();

        }
    }
</script>